export default "__VITE_ASSET__CuEHDML5__"